import { useDetailPageContext } from "../../Provider/DetailV2";
import {
  StyledSummaryBarCellEditableValueElement,
  StyledSummaryBarCellValueElement,
} from "./Detail.styles";

const SummaryBarCellValue = ({ children }) => {
  return <StyledSummaryBarCellValueElement>{children}</StyledSummaryBarCellValueElement>;
};

const SummaryBarCellEditableValue = ({ inputName }) => {
  const { formik } = useDetailPageContext();

  const handleInputChange = e => {
    formik.setFieldValue(inputName, e.target.value);
  };
  return (
    <StyledSummaryBarCellEditableValueElement
      onChange={handleInputChange}
      value={formik.values[inputName]}
    />
  );
};

export { SummaryBarCellValue, SummaryBarCellEditableValue };
